export default __webpack_public_path__ + "static/media/NEW.9a13fed3.png";